<template>
	<div>
		<div class="xs-12 mt6">
			<div class="block mb2">
				<span class="fw7">原因A</span> - 账户持有人应纳税的国家不向其居民发放TIN
				(如开曼群岛不发放TIN)。
			</div>
			<div class="block mb2 lh125">
				<span class="fw7">原因B</span> -
				账户持有人申请了TIN或等效号码。如果您选择原因B,您同意将在从相关税务机关收到该号码后30天内提供给本公司。
			</div>
			<div class="block mb2 lh125">
				<span class="fw7">原因C</span> - 本表格上不要求提供TIN。 (注意:
				只有在上表中所列的税务居所司法管辖区的税务机关颁布了本地法律,不要求为OECD
				CRS提供TIN的情况下,才可选择原因C)
			</div>
			<div class="block lh125">
				<span class="fw7">原因 D</span> -
				账户持有人没有申请TIN或等效号码或无法获得TIN或等效号码。如果选择原因D,请在下面方框中解释原因。
			</div>
		</div>
		<!-- Form -->
		<!-- Q1 -->
		<div class="xs-12 fs4 fw7 mt6 mb2">税务居民身份</div>
		<case-form
			v-for="i in 3"
			:key="i"
			:schema="schemaTaxResidency(i)"
			class="mb6"
		/>

		<case-form :schema="schemaOthers" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "../../../../CaseForm/CaseForm.vue"

export default {
	components: {
		CaseForm
	},
	computed: {
		schemaOthers() {
			return [
				{
					label: "请勾选此选项以更新我们记录中账户持有人的邮寄地址",
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderhasProvidedApplicableTaxCN`,
					props: {
						suggest: {
							typeIncludes: `hasProvidedApplicableTaxCN`
						},
						createOptions: {
							type: `hasProvidedApplicableTaxCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: `如果选择原因D,请在下面方框中解释原因。`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdernoTaxpayerIdentificationNumberReasonCN`,
					props: {
						suggest: {
							typeIncludes: `noTaxpayerIdentificationNumberReasonCN`
						},
						createOptions: {
							type: `noTaxpayerIdentificationNumberReasonCN`,
							dataType: "string"
						}
					}
				},
				{
					label: `第一部分中的账户持有人是特定美国人吗 (有关特定美国人的定义,请参阅附录1)?`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderisSpecifiedUSPersonCN`,
					props: {
						suggest: {
							typeIncludes: `isSpecifiedUSPersonCN`
						},
						createOptions: {
							type: `isSpecifiedUSPersonCN`,
							dataType: "boolean",
							defaultValue: false
						}
					}
				},
				{
					label: `请解释为什么账户持有人在该国保持住所或邮寄地址,但不认为自己是该国的税务居民:`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderdifferentResidentAndMailingAddressReasonCN`,
					props: {
						suggest: {
							typeIncludes: `differentResidentAndMailingAddressReasonCN`
						},
						createOptions: {
							type: `differentResidentAndMailingAddressReasonCN`,
							dataType: "string"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaTaxResidency(i) {
			return [
				{
					label: `税务居所司法管辖区 ${i}`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holderjurisdictionOfTaxResidence${i}CN`,
					props: {
						suggest: {
							typeIncludes: `jurisdictionOfTaxResidence${i}CN`
						},
						createOptions: {
							type: `jurisdictionOfTaxResidence${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `(该税号显示在相关司法管辖区政府所得税表格中。
请按照政府税务表格上要求的格式输入TIN) ${i}`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdertaxpayerIdentificationNumber${i}CN`,
					props: {
						suggest: {
							typeIncludes: `taxpayerIdentificationNumber${i}CN`
						},
						createOptions: {
							type: `taxpayerIdentificationNumber${i}CN`,
							dataType: "string"
						}
					}
				},
				{
					label: `如果无法获得TIN,请按照如下说明输入原因A、B、C或D
(并且如果选择原因D,请解释)`,
					component: "entityFact",
					entity: "case.holder",
					relation: "case.holder.facts",
					bindTo: `case.facts.holdernoTaxpayerNumber${i}CN`,
					props: {
						suggest: {
							typeIncludes: `noTaxpayerNumber${i}CN`
						},
						createOptions: {
							type: `noTaxpayerNumber${i}CN`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
